import { WorkflowStatusBadge } from '../../../higher-order/workflow-status-badge.component';
import { orderStatusBackgroundColors } from '../../../../../features/orders/orders.constants';
import { Colors } from '../../../../theme/colors';
import { ResultIdentity } from './result-identity.component';
import { dataString } from '../search.utils';
import { convertHyphenated } from '../../../../../core/util/string-conversion';

export interface ResultStatusColumnProps {
  data: Record<string, unknown>;
  /** Which `data` key carries the lifecycle value: `state` for deliveries, `status` for orders. */
  statusKey: 'state' | 'status';
}

/**
 * Trailing-column content for a delivery/order result row: the status badge above the
 * project/retailer identity — logo when available, name otherwise.
 */
export function ResultStatusColumn({ data, statusKey }: ResultStatusColumnProps) {
  const status = dataString(data, statusKey);

  return (
    <>
      {status && (
        <WorkflowStatusBadge
          condensed
          fontSize="11px"
          showTooltip={false}
          style={{ maxWidth: '100%' }}
          label={convertHyphenated(status, { capitalizeEachWord: true })}
          color={
            orderStatusBackgroundColors[status as keyof typeof orderStatusBackgroundColors] ??
            Colors.bookedScannedInProgressGray
          }
        />
      )}
      <ResultIdentity name={dataString(data, 'projectName')} imageURL={dataString(data, 'projectImageURL')} />
    </>
  );
}
